import '../components/styles/Button.css';
import { useState, useEffect } from 'react';
import Loader from '../components/layouts/Loader';

import { BoxText } from '../components/layouts/BoxText';
import BottomNav from '../components/layouts/BottomNav';
import Footer from '../components/layouts/Footer';

function Portfolio() {

    const [profile, setProfile] = useState([]);
    const [loader, setLoader] = useState(true);

    useEffect(() => {

        fetch('data.json')

            .then((res) => res.json())

            .then((data) => (
                setProfile(data)
            ))

        setTimeout(() => {

            setLoader(false);

        }, 1000);

    }, []);

    return (

        <>

            {

                loader ?

                    <div className="loader__c">

                        <Loader />

                    </div>

                    :

                    <>

                        <div className='container animate__animated animate__fadeIn'>

                            {profile.length > 0 && profile.map((item, index) =>

                                <div className='portfolio_c' key={item.name}>

                                    <div className={`box_img ${(index + 1) % 2 === 0 && 'box_img-order'}`}>

                                        <img src={item.image} alt={item.name} />

                                    </div>

                                    <div className={`box_txt ${(index + 1) % 2 === 0 && 'box_txt-order'}`}>

                                        <BoxText
                                            key={item.name}
                                            {...item}
                                        />

                                    </div>

                                </div>

                            )}

                            <BottomNav />

                        </div>


                        <Footer />

                    </>

            }

        </>

    )

}

export default Portfolio;